import React from 'react';
import './VideoPreview.css';

function extractVideoId(url) {
  if (!url) {
    return null;
  }

  const matchWatch = url.match(/[?&]v=([a-zA-Z0-9_-]{11})/);
  if (matchWatch) {
    return matchWatch[1];
  }

  const matchShort = url.match(/youtu\.be\/([a-zA-Z0-9_-]{11})/);
  if (matchShort) {
    return matchShort[1];
  }

  const matchEmbed = url.match(/youtube\.com\/embed\/([a-zA-Z0-9_-]{11})/);
  if (matchEmbed) {
    return matchEmbed[1];
  }

  const matchShorts = url.match(/youtube\.com\/shorts\/([a-zA-Z0-9_-]{11})/);
  if (matchShorts) {
    return matchShorts[1];
  }

  return null;
}

const VideoPreview = ({ videoUrl, title = 'Video Preview', showTitle = true, className = '' }) => {
  const videoId = extractVideoId(videoUrl);

  if (!videoId) {
    return null;
  }

  return (
    <div className={`video-preview-card ${className}`.trim()}>
      {showTitle && <p className="video-preview-title">{title}</p>}
      <div className="video-preview-embed">
        <iframe
          src={`https://www.youtube.com/embed/${videoId}`}
          title={title}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
    </div>
  );
};

export default VideoPreview;
